/*
* Copyright (c) 2023 Eugenio Espinoza
*/

import React from 'react';
import { Link } from 'react-router-dom';
import './ArtistsGlance.css';

import melodico from '../../imgs/artists/melodico_img.jpg';
import donAero from '../../imgs/artists/don_aero_img.jpg';
import oscarC from '../../imgs/artists/Oscar_C_img.jpg';
import dubG from '../../imgs/artists/dub-g_img.jpg';
import swat from '../../imgs/artists/swat_img.jpg';

const ROSTER = [
  { name: 'Melódico', origin: 'Guadalajara, MX', year: '2015', to: '/melodico', img: melodico },
  { name: 'Don Aero', origin: 'Ciudad Juárez, MX', year: '2017', to: '/donaero', img: donAero },
  { name: 'Oscar C', origin: 'Chicago, IL', year: '2019', to: '/oscarc', img: oscarC },
  { name: 'Dub-G', origin: 'Guadalajara, MX', year: '2020', to: '/dubg', img: dubG },
  { name: 'SWAT', origin: 'Monterrey, MX', year: '2021', to: '/swat', img: swat },
];

function ArtistsGlance() {
  return (
    <section className="mt-roster">
      <div className="mt-roster__head mt-container">
        <div>
          <span className="mt-eyebrow">The Roster · 05 Artists</span>
          <h2 className="mt-roster__title">
            A house<br /><em>of voices.</em>
          </h2>
        </div>
        <div className="mt-roster__intro">
          <p>
            Cada artista en Mastered Trax es una firma individual — un lenguaje,
            una ciudad, una historia. Esto es un vistazo al roster.
          </p>
          <Link to="/artists" className="mt-roster__all">
            <span>See all artists</span>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
              <path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </Link>
        </div>
      </div>

      <div className="mt-roster__strip">
        {ROSTER.map((a, i) => (
          <Link to={a.to} key={a.name} className="mt-roster__card" style={{ '--mt-delay': `${i * 60}ms` }}>
            <div className="mt-roster__img">
              <img src={a.img} alt={a.name} loading="lazy" />
              <span className="mt-roster__num">0{i + 1}</span>
            </div>
            <div className="mt-roster__meta">
              <h3>{a.name}</h3>
              <div className="mt-roster__metaRow">
                <span>{a.origin}</span>
                <span>Signed · {a.year}</span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}

export default ArtistsGlance;
